import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { CATEGORY_QUERY_NAME } from '../../../../const';
import { addCategoryFilter, getCategoriesState } from '../../../../store/slices/catalogSlice';
import Spinner from '../../Spinner';
import styles from './styles.module.scss';

const CatalogSubheader = ({ pathName }) => {
    const { loading, categoriesList } = useSelector(getCategoriesState);
    const { t } = useTranslation();
    return (
        <div className={styles.subheader}>
            <nav className={styles.navigation}>
                {loading ? (
                    <div className={styles.spinner}>
                        <Spinner widht={48} height={48} />
                    </div>
                ) : !!categoriesList?.length ? (
                    <div className={styles.wrapper}>
                        {categoriesList.map((obj, i) => {
                            const { id, name } = obj;
                            if (i <= 5) {
                                return <SubheaderLink key={id} id={id} name={name} isLast={i === 5} pathName={pathName} />;
                            }
                        })}
                    </div>
                ) : (
                    <p>{t('labels.noCategory')}</p>
                )}
            </nav>
        </div>
    );
};

const SubheaderLink = (props) => {
    const { id, name, isLast = false, pathName } = props;
    const dispatch = useDispatch();
    const { activeCategoriesFilters, loading, categoriesList } = useSelector(getCategoriesState);
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const goToCategoryWithFilter = () => {
        if (loading) {
            return;
        }

        if (pathname === `${pathName}`) {
            if (!activeCategoriesFilters.some((cat) => cat === id)) {
                dispatch(addCategoryFilter({ filters: id, reset: true }));
            }
            return;
        }
        const advisor = categoriesList.find((category) => category?.id === id);
        navigate(`${pathName}/${CATEGORY_QUERY_NAME}=${advisor?.alias}`);
    };

    return (
        <>
            <button className={styles.link} onClick={goToCategoryWithFilter}>
                {name}
            </button>
            {!isLast && <div className={styles.divider}></div>}
        </>
    );
};

export default CatalogSubheader;
